import { render, staticRenderFns } from "./YandexModal.vue?vue&type=template&id=59a90270&"
import script from "./YandexModal.vue?vue&type=script&lang=js&"
export * from "./YandexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports